<nav class="sidebar" [class.is-collapsed]="collapsed()" aria-label="Main navigation">
  <a class="sidebar__brand" routerLink="/dashboard" [attr.aria-label]="config.appName + ' home'">
    <app-brand-mark />
    @if (!collapsed()) {
      <span class="sidebar__brand-text">
        <strong>Vintech</strong>
        <small>Central Portal</small>
      </span>
    }
  </a>

  <div class="sidebar__scroll">
    @for (group of groups(); track group.label) {
      <div class="sidebar__group">
        @if (collapsed()) {
          <hr class="sidebar__divider" />
        } @else {
          <div class="sidebar__group-label">{{ group.label }}</div>
        }
        <ul class="sidebar__list">
          @for (item of group.items; track item.route) {
            <li>
              <a
                class="sidebar__link"
                [routerLink]="item.route"
                routerLinkActive="is-active"
                ariaCurrentWhenActive="page"
                [ngbTooltip]="collapsed() ? item.label : ''"
                placement="end"
                container="body"
              >
                <i class="fa-solid fa-fw {{ item.icon }}" aria-hidden="true"></i>
                @if (!collapsed()) {
                  <span>{{ item.label }}</span>
                } @else {
                  <span class="visually-hidden">{{ item.label }}</span>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    } @empty {
      @if (!collapsed()) {
        <p class="sidebar__empty">No modules are assigned to your role yet.</p>
      }
    }
  </div>

  <button type="button" class="sidebar__collapse d-none d-lg-flex" (click)="theme.toggleSidebar()" [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'">
    <i class="fa-solid" [class.fa-angles-left]="!collapsed()" [class.fa-angles-right]="collapsed()" aria-hidden="true"></i>
    @if (!collapsed()) {
      <span>Collapse</span>
      <small class="sidebar__version">v{{ config.appVersion }}</small>
    }
  </button>
</nav>
